import { UseMutationResult } from '@tanstack/react-query';
import classNames from 'classnames';
import { useCallback } from 'react';
import { Button } from 'ui';
import { ArchiveIcon } from 'ui/icons';

interface ArchivedItemAction {
  id: number;
  mutation: () => UseMutationResult<unknown, unknown, number>;
  classes?: {
    container?: string;
    label?: string;
  };
}

const ArchivedItemAction = ({ id, mutation, classes }: ArchivedItemAction) => {
  const { mutateAsync, isLoading } = mutation();

  const handleRestore = useCallback(() => {
    mutateAsync(id);
  }, [id, mutateAsync]);
  return (
    <div
      className={classNames('flex items-center justify-between w-[225px]', classes?.container)}
      onClick={e => e.stopPropagation()}
    >
      <div className="flex gap-3 items-center">
        <img src={ArchiveIcon} alt="archived" />
        <span className={classNames('text-gray-500 text-sm', classes?.label)}>Archived</span>
      </div>
      <Button
        variant="secondary"
        className="w-fit h-[32px] min-h-[32px] py-0 bg-white"
        disabled={isLoading}
        onClick={handleRestore}
        loading={isLoading}
      >
        Restore
      </Button>
    </div>
  );
};

export default ArchivedItemAction;
